class InvalidContainerIdError extends Error {
    constructor(containerId) {
        super(`invalid GTM container Id: "${containerId}"`);
    }
}

export default InvalidContainerIdError;
